import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface I_IndicatorFormMeta {
    // Input Mode Code POS information
    capacityEntryCard: FormInputMeta;
    operatingEnvironment: FormInputMeta;
    carrierAuthenticationCapacity: FormInputMeta;
    carrierPresenceIndicator: FormInputMeta;
    cardCaptureCapacity: FormInputMeta;
    dataReadingMode: FormInputMeta;
    cardRewritingCapacity: FormInputMeta;
    cardAuthenticationMethod: FormInputMeta;
    cardPresenceIndicator: FormInputMeta;
    cardAuthenticationEntity: FormInputMeta;
    capacityPinEntry: FormInputMeta;
    catLevelIndicator: FormInputMeta;

    // Others information
    purchaseIdentificationFormat: FormInputMeta;
    mailPhoneEcommerce: FormInputMeta;
    chipCondition: FormInputMeta;
    purchaseID: FormInputMeta;
    developmentServiceField: FormInputMeta;

    schema: any;
}

const indicatorFormMeta = {} as I_IndicatorFormMeta;

// Input Mode Code POS information
indicatorFormMeta.capacityEntryCard = {
  name: "capacityEntryCard",
  type: "text",
  label: "Capacité Entrée Donnée Carte",
  placeholder: "",
  validation: yup.string()
};

indicatorFormMeta.operatingEnvironment = {
  name: "operatingEnvironment",
  type: "text",
  label: "Environnement d'exploitation",
  placeholder: "",
  validation: yup.string()
};

indicatorFormMeta.carrierAuthenticationCapacity = {
  name: "carrierAuthenticationCapacity",
  type: "text",
  label: "Capacité Authentification Porteur",
  placeholder: "",
  validation: yup.string()
};

indicatorFormMeta.carrierPresenceIndicator = {
  name: "carrierPresenceIndicator",
  type: "text",
  label: "Indicateur Présence Porteur",
  placeholder: "",
  validation: yup.string()
};

indicatorFormMeta.cardCaptureCapacity = {
  name: "cardCaptureCapacity",
  type: "text",
  label: "Capacité Capture Carte",
  placeholder: "",
  validation: yup.string()
};

indicatorFormMeta.dataReadingMode = {
  name: "dataReadingMode",
  type: "text",
  label: "Mode Lecture Donnée",
  placeholder: "",
  validation: yup.string()
};

indicatorFormMeta.cardRewritingCapacity = {
  name: "cardRewritingCapacity",
  type: "text",
  label: "Capacity Réecriture Carte",
  placeholder: "",
  validation: yup.string()
};

indicatorFormMeta.cardAuthenticationMethod = {
  name: "cardAuthenticationMethod",
  type: "text",
  label: "Méthode Authentification Carte",
  placeholder: "",
  validation: yup.string()
};

indicatorFormMeta.carrierPresenceIndicator = {
  name: "carrierPresenceIndicator",
  type: "text",
  label: "Indicateur Présence Carte",
  placeholder: "",
  validation: yup.string()
};

indicatorFormMeta.cardAuthenticationEntity = {
  name: "cardAuthenticationEntity",
  type: "text",
  label: "Entité Authentification Carte",
  placeholder: "",
  validation: yup.string()
};

indicatorFormMeta.capacityPinEntry = {
  name: "capacityPinEntry",
  type: "text",
  label: "Capacité Entrée PIN",
  placeholder: "",
  validation: yup.string()
};

indicatorFormMeta.catLevelIndicator = {
  name: "catLevelIndicator",
  type: "text",
  label: "Indicateur Niveau CAT",
  placeholder: "",
  validation: yup.string()
};

// Others information
indicatorFormMeta.purchaseIdentificationFormat = {
  name: "purchaseIdentificationFormat",
  type: "text",
  label: "Format Identification Achat",
  placeholder: "",
  validation: yup.string()
};

indicatorFormMeta.mailPhoneEcommerce = {
  name: "mailPhoneEcommerce",
  type: "text",
  label: "Mail/Telephone or E-commerce",
  placeholder: "",
  validation: yup.string()
};

indicatorFormMeta.chipCondition = {
  name: "chipCondition",
  type: "text",
  label: "Condition Puce",
  placeholder: "",
  validation: yup.string()
};

indicatorFormMeta.purchaseID = {
  name: "purchaseID",
  type: "text",
  label: "Identifiant Achat",
  placeholder: "",
  validation: yup.string()
};

indicatorFormMeta.developmentServiceField = {
  name: "developmentServiceField",
  type: "text",
  label: "Champ Service Developpement",
  placeholder: "",
  validation: yup.string()
};


indicatorFormMeta.schema = yup.object().shape(getValidationSchema(indicatorFormMeta));

export default indicatorFormMeta;